import { useState } from 'react';

// graphql
import { PageInfo, useCashiersQuery } from '@/generated/graphql';

// material ui
import { Box, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

// interfaces
import { ICashierTable, ICashierQueryVariable, mapGQLCashier } from '@/shared/interfaces';

// components
import { TableCashiers } from './components/cashiers/cashiers-table';
import { CashChipsSummary } from './components/cash-chips-summary';
import { TerminalBalance } from './components/terminal-balance/terminal-balance';
import { TerminalProfitLoss } from './components/terminal-profit-loss/terminal-profit-loss';
import { CashiersChips } from './components/cashiers-chips/cashiers-chips';
import { CashierCash } from './components/cashier-cash/cashier-cash';
import { CashiersCmp } from './components/cashiers/cashiers';

// modals
import { ModalManageCash } from './components/cashier-cash/modal-manage-cash';
import { ModalManageCashiersChips } from './components/cashiers-chips/modal-manage-chips';
import { ModalManageTerminalChips } from './components/terminal-balance/modal-manage-chips';
import { ModalManageTerminalProfitLoss } from './components/terminal-profit-loss/modal-manage-profit-loss';

export const CashiersPage = () => {
  // related chips summary states
  const [chipsSummaryRefetch, setChipsSummaryRefetch] = useState('');

  // related cashier cash states
  const [openManageCashMdl, setOpenManageCashMdl] = useState<boolean>(false);
  const [refetchCashierCashQuery, setRefetchCashierCashQuery] = useState<boolean>(false);

  // related cashier cash states
  const [openManageCashiersChipsMdl, setOpenManageCashiersChipsMdl] = useState<boolean>(false);
  const [refetchCashiersChipsQuery, setRefetchCashiersChipsQuery] = useState<boolean>(false);

  // related terminal balance states
  const [openManageTerminalChipsMdl, setOpenManageTerminalChipsMdl] = useState<boolean>(false);
  const [refetchTerminalChipsQuery, setRefetchTerminalChipsQuery] = useState<boolean>(false);

  // related terminal profit loss states
  const [openManageTerminalProfitLossMdl, setOpenManageTerminalProfitLossMdl] = useState<boolean>(false);
  const [refetchTerminalProfitLossQuery, setRefetchTerminalProfitLossQuery] = useState<boolean>(false);

  // end

  const [cashiers, setCashiers] = useState<ICashierTable[]>([]);

  const [tabValue, setTabValue] = useState('1');

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  return (
    <>
      <CashChipsSummary
        openManageCashMdl={setOpenManageCashMdl}
        setOpenManageCashiersChipsMdl={setOpenManageCashiersChipsMdl}
        chipsSummaryRefetch={chipsSummaryRefetch}
        setChipsSummaryRefetch={setChipsSummaryRefetch}
        setOpenManageTerminalChipsMdl={setOpenManageTerminalChipsMdl}
        setOpenManageTerminalProfitLossMdl={setOpenManageTerminalProfitLossMdl}
        setTabValue={setTabValue}
      />
      <Box sx={{ width: '100%', typography: 'body1', ml: 1 }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
              <Tab label="Cashiers" value="1" />
              <Tab label="Cashiers Cash" value="2" />
              <Tab label="Cashiers Chips" value="3" />
              <Tab label="Terminal Limit Transfer" value="4" />
              <Tab label="Terminal Profit Loss" value="5" />
            </TabList>
          </Box>
          <TabPanel value="1" style={{ padding: '0em' }}>
            <CashiersCmp cashiers={cashiers} setCashiers={setCashiers} />
          </TabPanel>
          <TabPanel value="2" style={{ padding: '0em' }}>
            <CashierCash refetchCashierCashQuery={refetchCashierCashQuery} setRefetchCashierCashQuery={setRefetchCashierCashQuery} />
          </TabPanel>
          <TabPanel value="3" style={{ padding: '0em' }}>
            <CashiersChips
              refetchCashiersChipsQuery={refetchCashiersChipsQuery}
              setRefetchCashiersChipsQuery={setRefetchCashiersChipsQuery}
            />
          </TabPanel>

          <TabPanel value="4" style={{ padding: '0em' }}>
            <TerminalBalance
              refetchTerminalChipsQuery={refetchTerminalChipsQuery}
              setRefetchTerminalChipsQuery={setRefetchTerminalChipsQuery}
            />
          </TabPanel>
          <TabPanel value="5" style={{ padding: '0em' }}>
            <TerminalProfitLoss
              refetchTerminalProfitLossQuery={refetchTerminalProfitLossQuery}
              setRefetchTerminalProfitLossQuery={setRefetchTerminalProfitLossQuery}
            />
          </TabPanel>
        </TabContext>
      </Box>
      {/* MODALS */}
      <ModalManageCash
        open={openManageCashMdl}
        setOpen={setOpenManageCashMdl}
        cashiers={cashiers}
        setRefetchCashierCashQuery={setRefetchCashierCashQuery}
      />
      <ModalManageCashiersChips
        open={openManageCashiersChipsMdl}
        setOpen={setOpenManageCashiersChipsMdl}
        setRefetchCashiersChipsQuery={setRefetchCashiersChipsQuery}
        setChipsSummaryRefetch={setChipsSummaryRefetch}
      />
      <ModalManageTerminalChips
        open={openManageTerminalChipsMdl}
        setOpen={setOpenManageTerminalChipsMdl}
        setRefetchTerminalChipsQuery={setOpenManageTerminalChipsMdl}
        setChipsSummaryRefetch={setChipsSummaryRefetch}
      />
      <ModalManageTerminalProfitLoss
        cashiers={cashiers}
        open={openManageTerminalProfitLossMdl}
        setOpen={setOpenManageTerminalProfitLossMdl}
        setRefetchTerminalProfitLossQuery={setRefetchTerminalProfitLossQuery}
      />
    </>
  );
};
